import React from 'react';
import { createContext } from './context';

export const [pathContext, PathContextProvider] = createContext<[Array<string>, React.Dispatch<React.SetStateAction<Array<string>>>]>();
